import asyncComponent from '../common/utils/async-component.js';

const ApiKeys = asyncComponent(() => import('./components/api-keys/index.js'));
const ApiKeyCreate = asyncComponent(() => import('./components/api-key-create/index.js'));

export default {
  '/api-keys': {
    components: { main: ApiKeys },

    '/create': {
      components: { main: ApiKeyCreate }
    }
  }
};
